import { signOut } from '@firebase/auth';
import React from 'react'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { logout, selectUser } from '../../features/user/userSlice';
import { auth } from '../../firebase';
import MovieCard from '../movie-card/MovieCard';
import PageHeader from '../page-header/PageHeader';
import "./bookmark.scss"
export default function Bookmarks() {
    const dispatch = useDispatch()
    const user = useSelector(selectUser)
    const capitalize=(word)=> {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    }

    return (
      <>
        <PageHeader>Bookmarks</PageHeader>
        <div className="container">
          <div className="section mb-3">
            <div className="info">
              <h3>
                Welcome{" "}
                <span className="user__name">
                  {user.displayName
                    .split(" ")
                    .map((ele) => capitalize(ele))
                    .join(" ")}
                </span>{" "}
                to your Booking List
              </h3>
              <Link
                to="/login"
                onClick={() => {
                  signOut(auth);
                  dispatch(logout());
                }}
              >
                Sign out{" "}
              </Link>
            </div>
            
            <div className="movie-grid">
              {user.bookingList.map((item, i) => (
                <MovieCard category={item.category} item={item} key={i} />
              ))}
            </div>
          </div>
        </div>
      </>
    );
}
